import React, { Component } from "react";
import moment from 'moment';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";
import CircularProgress from "@material-ui/core/CircularProgress";

const backend = require('../../config.js').backend;

class Pending_Ministry_Donations_Report extends Component {

    constructor(props) {
        super(props);

        this.state = {
            reports: {},
            allDesigs: {},
            isButtonDisabled: false,
            staffId: sessionStorage.getItem('id_e'),
            staffName: sessionStorage.getItem('name'),
            staffEmail: sessionStorage.getItem('email'),
            redirectLogout: false
        }

    }



    componentDidMount() {

        this.getDesigs();
        this.getReports();
    }


    // get all pending pdf files
    getReports = () => {

        // return new Promise(function(resolve, reject){

        var status = 'confirmed'
        fetch(backend + `api/v1/ministrydonationsreport?status=` + status, {
            method: 'GET',
            credentials: "include"
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    // console.log(data.error);

                    if (data.redirect) {
                        this.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (data.error === 'no return from set confirmedFiles') {
                        this.setState({ reports: {} });
                    }
                    else {
                        NotificationManager.error('ERROR:' + data.error);
                    }
                }

                else {
                    this.setState({ reports: data.reports });
                }


            })
            .catch(error => {
                // console.log(error);
            });


        // })

    }


    renderReportButtons = (report, desigId, index) => {

        // console.log(report)

        let fileName = report.fileName;
        let filePath = report.filePath;
        let creatorName = report.creatorName;
        let creatorEmail = report.creatorEmail;
        let content;


        if (report.status === 'confirmed') {

            content = (<td className='action'>
                <button
                    type="button"
                    className="btn btn-primary submit"
                    onClick={() => this.handleApprove(fileName, filePath, desigId, index, creatorName, creatorEmail)}
                >
                    Approve
                </button>
                <VisibilityIcon onClick={() => this.handleCheck(report)} />
                <DeleteIcon onClick={() => this.handleDelete(fileName, desigId, index)} />

            </td>)

        }

        else {

            content = (<td className='action'>
                <div className='action-group'>
                    <div className='action-text'>
                        <span>Approved</span>
                    </div>
                    <VisibilityIcon onClick={() => this.handleCheck(report)} />
                    <DeleteIcon onClick={() => this.handleDelete(fileName, desigId, index)} />
                </div>

            </td>)

        }
        return content

    }


    getDesigs = () => {

        fetch(backend + `api/v1/gift/alldesignames`, {
            method: 'GET',
            credentials: "include"
        })
            .then(response => response.json())
            .then((data) => {
                // console.log(data);

                if (data.redirect) {
                    this.setState({ redirectLogout: true })
                    window.location.reload(false);
                } else {
                    this.setState({ allDesigs: data })
                }
            })
            .catch((err) => {
                // console.log('getDesigs', err);
            })

    }

    getPdfDataStream = (filename) => {

        fetch(backend + `api/v1/ministrydonationsreport/pdf?filename=` + filename, {
            method: 'GET',
            credentials: "include"
        })
            .then(response => response.json())
            .then((data) => {

                if (data.redirect) {
                    this.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else if (data.error) {
                    // console.log(data.error)
                    NotificationManager.error('Getting PDF data error:' + data.error.code);
                }

                else {
                    this.setState({ renderPdf: data.data, checking: filename });
                }
            })
            .catch((err) => {
                NotificationManager.error('Getting PDF data error:' + err.toString());
            })
    }


    handleCheck = report => {

        this.getPdfDataStream(report.fileName);

    }


    handleApprove = (filename, filepath, desigId, index, creatorName, creatorEmail) => {

        this.approveOneFile(filename, filepath, desigId, index, creatorName, creatorEmail);

    }

    handleApproveAll = reports => {

        const _this = this;
        this.setState({ isButtonDisabled: true });
        var approvedFiles_promiseList = [];


        // eslint-disable-next-line array-callback-return
        Object.keys(reports).map(function (ministryId) {

            var oneMinistryReportList = reports[ministryId];
            // eslint-disable-next-line array-callback-return
            oneMinistryReportList.map((report, index) => {

                // _this.approveOneFile(report.fileName, report.filePath, ministryId, index);
                approvedFiles_promiseList.push(_this.approveOneFile(report.fileName, report.filePath, ministryId, index, report.creatorName, report.creatorEmail));
                // return 0;

            })
            // return 0;
        });


        Promise.all(approvedFiles_promiseList).then((fetch_results) => {
            if (this.checkAllTrue(fetch_results)) {
                this.setState({ isButtonDisabled: false })
            }
        })
            .catch(error => {
                // console.log(error);
            });

    }

    checkAllTrue = array => {
        return array.every(element => element === 'OK');
    }


    approveOneFile = (filename, filepath, desigId, index, creatorName, creatorEmail) => {

        const status = 'approved';
        var { staffId } = this.state;
        var { allDesigs } = this.state;
        var { staffName } = this.state;
        var { staffEmail } = this.state;

        var url = `api/v1/ministrydonationsreport/` + staffId + `?filename=` + filename + `&status=` + status;

        const _this = this;

        const file = {
            name: filename,
            path: filepath,
            desigName: allDesigs[desigId],
            creatorName: creatorName,
            creatorEmail: creatorEmail,
            approverName: staffName,
            approverEmail: staffEmail
        }

        return new Promise(function (resolve, reject) {

            fetch(backend + url, {
                method: 'PUT',
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'file': file })
            })
                .then(res => res.json())
                .then(res => {

                    if (res.redirect) {
                        _this.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (res.status === 500) {
                        NotificationManager.error(filename + ' cannot be approved due to ' + res.message);
                        resolve('OK')
                    }
                    else {
                        _this.updateReportStatusInList(desigId, index); // Change the status to green tick
                        resolve('OK')
                    }

                })
                .catch(err => {

                    NotificationManager.error(filename + ' cannot be approved due to ' + err);
                    reject(err)

                });

        })

    }

    updateReportStatusInList = (desigId, index) => {

        let { reports } = this.state;
        let reportList = reports[desigId];
        let report = reportList[index];

        report.status = 'approved';
        reportList[index] = report
        reports[desigId] = reportList;

        this.setState({ reports: reports });

    }


    handleDelete = (filename, desigId, index) => {

        // double check with user
        var answer = window.confirm("Are you sure you want to delete report " + filename + " ?")

        if (answer) {
            this.deleteOneFile(filename, desigId, index);

            if (this.state.checking && this.state.checking === filename) {
                this.setState({ renderPdf: undefined })
            }
        }

    }


    deleteOneFile = (filename, desigId, index) => {

        var { staffId } = this.state;
        // Delete it from Redis database
        var url = `api/v1/ministrydonationsreport/` + staffId + `?filename=` + filename;

        fetch(backend + url, {
            method: 'DELETE',
            credentials: "include"
        })
            .then(res => res.json())
            .then(res => {

                if (res.redirect) {
                    this.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else if (res.status === 404) {
                    NotificationManager.warning(res.message, '', 10000);
                    this.removeReportFromList(desigId, index); // Delete a report from frontend display
                }
                else if (res.status === 500) {
                    NotificationManager.error(res.message, '', 10000);
                }
                else {
                    this.removeReportFromList(desigId, index); // Delete a report from frontend display
                }

            })
            .catch(err => console.log(err));

    }

    removeReportFromList = (desigId, index) => {

        let { reports } = this.state;
        let reportList = reports[desigId];

        reportList.splice(index, 1);

        if (reportList.length === 0) { // no report left, delete the ministry record
            delete reports[desigId]
            this.setState({ reports: reports });
        }
        else {
            reports[desigId] = reportList;
            this.setState({ reports: reports });
        }

    }


    renderReportRow = (report, index, desigId) => {

        // console.log('renderReportRow', report, index, desigId)

        if (index === 0) {
            return null
        }
        else {
            return (
                <tr key={index}>
                    <td>{report.fileName}</td>
                    <td>{moment(report.createDate, 'YYYYMMDDHHmmss').format('DD-MMM-YYYY')}</td>
                    <td>{report.status}</td>
                    {this.renderReportButtons(report, desigId, index)}
                </tr>
            )
        }


    }

    renderReports = (reports, desigId) => {

        let length = reports.length;
        var { allDesigs } = this.state;
        var DesigName = allDesigs[desigId];
        var first_report = reports[0]; // render first row with rowspan
        var createDate = first_report.createDate;

        const init_index = 0;

        return (
            <React.Fragment>
                <tr key={init_index}>
                    <td className='multiRow' rowSpan={length}>{DesigName}</td>
                    <td>{first_report.fileName}</td>
                    <td>{moment(createDate, 'YYYYMMDDHHmmss').format('DD-MMM-YYYY')}</td>
                    <td>{first_report.status}</td>
                    {this.renderReportButtons(first_report, desigId, init_index)}
                </tr>
                {length > 1 ?
                    reports.map((r, i) => this.renderReportRow(r, i, desigId))
                    :
                    null
                }
            </React.Fragment>
        )

    }

    renderMinistryList = _ => {
        var { reports } = this.state;
        var { isButtonDisabled } = this.state;

        // loop reports to get all designIds and display it in table
        if (reports && Object.keys(reports).length) {
            return (
                <div>

                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Designation Name</th>
                                <th>Files</th>
                                <th>Create Date</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {Object.keys(reports).map((desigId, i) => (
                                this.renderReports(reports[desigId], desigId)
                            ))}
                        </tbody>

                    </table>

                    {(isButtonDisabled) ?
                        <button type="button" className="btn btn-primary submit right" onClick={() => this.handleApproveAll(reports)} disabled>Approve All</button>
                        :
                        <button type="button" className="btn btn-primary submit right" onClick={() => this.handleApproveAll(reports)}>Approve All</button>
                    }

                </div>

            )
        }

        else if (reports && (Object.keys(reports).length === 0)) {
            return (<h4 className='center'>No data returned</h4>)
        }

        else {
            return (
                <div style={{display:"flex", alignItems: "center", justifyContent: "center"}}>
                  <h4 className='title'>Loading... This may take a while... </h4>
                  <CircularProgress/>
                </div>)
        }

    }


    render() {

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        let ministryList = this.renderMinistryList();

        let content = (
            <div className="ministry-donations-report-approve">
                <h3 className="title">Pending Ministry Donations Report</h3>

                <div className="report-table">
                    {ministryList}
                </div>

                {this.state.renderPdf ?
                    <iframe
                        title="frame"
                        height="600px"
                        src={`data:application/pdf;base64,` + this.state.renderPdf}
                    /> : null}

                <NotificationContainer />

            </div>
        )

        return (content)




    }



}

export default Pending_Ministry_Donations_Report;
